module.exports = __webpack_public_path__ + "img/Bitmap@234x (3).ac931162.png";